import { fhaLimits, IFHAType } from './fha-limit-2026';

function normalizeStateNameKey(value: string) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

const SPECIAL_STATE_NAME_TO_ABBREVIATION: Record<string, string> = {
  'WASHINGTON DC': 'DC',
  'WASHINGTON D C': 'DC',
};

const STATE_NAME_TO_ABBREVIATION = fhaLimits.reduce((acc: Record<string, string>, row: IFHAType) => {
  const abbreviation = String(row?.ST || '').trim().toUpperCase();
  const stateName = normalizeStateNameKey(String(row?.['State Name'] || ''));
  if (!abbreviation || !stateName) return acc;
  acc[stateName] = abbreviation;
  return acc;
}, { ...SPECIAL_STATE_NAME_TO_ABBREVIATION });

export function normalizeUsState(value: unknown) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const upper = raw.toUpperCase();
  const lettersOnly = upper.replace(/[^A-Z]/g, '');
  if (lettersOnly.length === 2) return lettersOnly;

  return STATE_NAME_TO_ABBREVIATION[normalizeStateNameKey(raw)] || upper;
}

export function normalizeStateList(states: string[] | undefined) {
  if (!states || states.length === 0) return [];
  return [...new Set(states.map(state => normalizeUsState(state)).filter(Boolean))];
}
